import { CommonCardContainer } from "components/DashboardCards/cardStyles";
import HelperIcon from "components/HelperIcon/HelperIcon";
import InfoTooltip from "components/Tooltip/InfoTooltip";
import ThreeDotDropdown from "components/DropdownStyle/ThreeDotDropdown";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styled from 'styled-components';
import { HorizontalLineDivider } from "styledComponents/Activity";



import deleteWhiteIcon from "../../../assets/img/icons/delete_white.svg";
import goldenStarBadge from "../../../assets/img/icons/golden-star-badge.svg";
import LocationIcon from "../../../assets/img/icons/location_icon.svg";
import defaultLocationIcon from "../../../assets/img/icons/default-location-filled.svg";
import defaultHoverLocationIcon from "../../../assets/img/icons/default-location-new.svg";
import PlusBlack from "../../../assets/img/icons/plus_black_2.svg";
import Plus from "../../../assets/img/icons/plus_primary.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import PricingPlan from "../../../components/PricingPlan";
import { ButtonIcon, ButtonTakingFullWidth, DeleteButton, PrimaryButton, WhiteButton, WhiteButtonWithIcon } from "../../../styledComponents/buttons";
import { AddClientContainer, AddClientContainerNew, GeneralInfoItem, GeneralInfoSection, GeneralInfoSection2, HoveredSectionClient, LocationItem, LocationContent } from "../../../styledComponents/clients";
import { CardTitle, CommonFlex, CommonGrid, CommonImage, CommonText, Container, ContainerNew, ContentHeader, FormAlert, InputField, InputLabel, InputWithLabelSection, ManagerBadge, PageTitle } from "../../../styledComponents/common";
import { ButtonFlexContainer, RedStar } from "../../../styledComponents/members";
import { checkHtml, checkUrl, validateEmail } from "../../../utils/helper";
import { DataAndMapContainer } from "../../FieldServices/JobSites/jobSitesStyles";
import { MapAndAlertContainer } from "../../FieldServices/RouteMap/routeMapStyles";
import AddLocationModal from "../ClientDetails/AddLocationModal";
import StaticTaskLocationModal from "../ClientDetails/StaticTaskLocationModal";


// import ClientMap from './ClientMap';

export const MapButton = styled.button`
  /* Frame 2087324781 */
  box-sizing: border-box;
  
  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  gap: 10px;
  
  width: 55px;
  height: 32px;
  
  background: #E9F0FE;
  border: 1px solid #B7CDFA;
  border-radius: 32px;
  

  
  /* Map */
  font-family: 'Mona Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */
  color: #353A46;
  
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #dbe6e4;
  }
`;

const AddClient = props => {
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [officeLocation, setOfficeLocation] = useState("");
  const [saveErrors, setSaveErrors] = useState({});
  const [save, setSave] = useState(false);
  const [pricingPopup, setPricingPopup] = useState(false);
  const [duplicateEmail, setDuplicateEmail] = useState(false);
  const [action, setAction] = useState("create");
  const [popupOpen, setPopupOpen] = useState(false);
  const [clientLocationList, setClientLocationList] = useState([]);
  const [staticLocationModalOpen, setStaticLocationModalOpen] = useState(false);
  const [selectedStaticLocation, setSelectedStaticLocation] = useState(null);
  const [locationIndex, setLocationIndex] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  const customerInputRef = useRef(null);

  const { t } = useTranslation();
  const { createdClientId } = props;

  const clearStates = () => {
    setClientName("");
    setClientEmail("");
    setPhoneNumber("");
    setSaveErrors({});
  };

  useEffect(() => {
    customerInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (props.duplicateEmail) {
      setDuplicateEmail(true);
    } else {
      setDuplicateEmail(false);
    }
  }, [props.duplicateEmail]);

  useEffect(() => {
    if (save && createdClientId !== null) {
      clearStates();
      props.history.push(`/user/customer-details?id=${createdClientId}`);
    }
  }, [createdClientId]);

  useEffect(() => {
    if (createdClientId && props.selectedOrganization?.id) {
      const step = props.appOnboardingSteps?.find(s => s.name === "add_customer");
      if (step && step.status !== "completed") {
        props.completeAppOnboardingStep(props.selectedOrganization.id, "add_customer");
      }
    }
  }, [createdClientId]);

  useEffect(() => {
    if (
      props.selectedOrganization?.plan?.name === "Standard" ||
      props.selectedOrganization?.plan?.nick_name === "standard-free"
    ) {
      pricingPopupToggle();
    }
  }, [props.selectedOrganization]);

  const onClientNameChange = e => {
    const { value } = e.target;
    setClientName(value);
    if (saveErrors && saveErrors["clientName"]) {
      delete saveErrors["clientName"];
    }
  };

  const onEmailChange = e => {
    setDuplicateEmail(false);
    const { value } = e.target;
    setClientEmail(value);
    if (saveErrors && saveErrors["clientEmail"]) {
      delete saveErrors["clientEmail"];
    }
  };

  const onAddressChange = e => {
    const { value } = e.target;
    setOfficeLocation(value);
  };

  const cancelFunction = () => {
    props.history.push({
      pathname: "/user/customers",
      state: { from: "create" },
    });
  };

  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  const handleSave = () => {
    if (checkError()) {
      if (props.selectedOrganization && props.selectedOrganization.id) {
        let payload = {
          organization_id: props.selectedOrganization.id,
          name: clientName,
          showToast: false,
          phone_number: phoneNumber
            ? phoneNumber.startsWith("+")
              ? phoneNumber
              : "+" + phoneNumber
            : null,
          email: clientEmail ? clientEmail : null,
          location_list: clientLocationList,
        };
        props.createClient(payload);
        setSave(true);
      }
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    if (!clientName.trim()) {
      formIsValid = false;
      saveErrors["clientName"] = t("please_enter_customer_name");
    } else if (clientName.length > 256) {
      formIsValid = false;
      saveErrors["clientName"] = t(
        "please_enter_customer_name_within_256_characters",
      );
    } else if (checkUrl(clientName)) {
      formIsValid = false;
      saveErrors["clientName"] = t("client_name_can_not_contain_url");
    } else if (checkHtml(clientName)) {
      formIsValid = false;
      saveErrors["clientName"] = t("invalid_client_name");
    }
    if (!validateEmail(clientEmail)) {
      formIsValid = false;
      saveErrors["clientEmail"] = t("please_enter_a_valid_email_address");
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  const addLocationToggle = () => {
    setPopupOpen(!popupOpen);
    setAction("create");
  };

  const handleClientLocation = locationData => {
    // Add new location with temporary ID
    const newLocation = {
      ...locationData,
      tempId: Date.now() + Math.random(),
      default: locationData.default || false,
    };

    // If new location is default, remove default from all existing locations
    const updatedList = clientLocationList.map(loc => ({
      ...loc,
      default: newLocation.default ? false : loc.default,
    }));

    setClientLocationList([...updatedList, newLocation]);
    setPopupOpen(false);
  };

  const handleClientLocationDelete = index => {
    const updatedList = clientLocationList.filter((_, i) => i !== index);
    setClientLocationList(updatedList);
  };

  const onHoverChange = index => {
    setHoveredId(index);
  };

  const handleShowLocation = (location, index) => {
    // Ensure static modal receives an id; use tempId for newly added locations
    const locationWithId = {
      ...location,
      id: location.id || location.tempId,
    };
    setSelectedStaticLocation(locationWithId);
    setLocationIndex(index);

    setTimeout(() => {
      setStaticLocationModalOpen(true);
    }, 300);
  };

  return (
    <div className="content">
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText="You don't have permission to this feature."
        popupTitle="Upgrade to Elite to access this feature"
        history={props.history}
        backRoute="/user/dashboard"
        onlyElite
      />
      {/* <PageTitle>{t("customers")}</PageTitle> */}
      <ContentHeader>
        <BackButtonComponent
          onClick={() => props.history.push("/user/customers")}
          subTitle="Back to All Customers"
        />
      </ContentHeader>
      {props.selectedOrganization?.id && (
        <AddLocationModal
          isOpen={popupOpen}
          toggle={addLocationToggle}
          addClientLocation={handleClientLocation}
          organization_id={props.selectedOrganization.id}
          selectedOrganization={props.selectedOrganization}
          action={action}
        />
      )}

      <ContainerNew marginTop="12px" padding="24px">
        <CommonFlex disableResponsive gap="0px">
          <CardTitle>{t("create_customer")}</CardTitle>
          <HelperIcon
            text={t(
              "provide_basic_points_of_contact_to_ensure_smooth_communication_and_dependable_client_records",
            )}
            margin="0 0 0 10px"
          />
        </CommonFlex>

        <CommonGrid
          gap="48px"
          disableResponsive
          responsiveBreakpoint="780px"
          responsiveColumns="1fr"
          alignItem="flex-start"
          columns="1fr 1fr"
        >
          <AddClientContainerNew marginTop="0">
            <CommonGrid
              disableResponsive
              responsiveColumns="1fr"
              responsiveBreakpoint="780px"
              justifyContent="none"
            >
              <InputWithLabelSection>
                <InputLabel>
                  {t("customer_name")} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type="text"
                  placeholder={t("type_customer_name_here")}
                  ref={customerInputRef}
                  value={clientName}
                  onChange={e => onClientNameChange(e)}
                  error={
                    saveErrors &&
                    saveErrors["clientName"] &&
                    saveErrors["clientName"] !== undefined
                  }
                />
                {saveErrors &&
                  saveErrors["clientName"] &&
                  saveErrors["clientName"] !== undefined && (
                    <FormAlert margin="0 0 0 5px">
                      {saveErrors["clientName"]}
                    </FormAlert>
                  )}
              </InputWithLabelSection>

              <InputWithLabelSection>
                <InputLabel>
                  {t("email_address")} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type="text"
                  placeholder={t("type_email_address_here")}
                  value={clientEmail}
                  onChange={e => onEmailChange(e)}
                  error={
                    saveErrors &&
                    saveErrors["clientEmail"] &&
                    saveErrors["clientEmail"] !== undefined
                  }
                />
                {saveErrors &&
                  saveErrors["clientEmail"] &&
                  saveErrors["clientEmail"] !== undefined && (
                    <FormAlert margin="0 0 0 5px">
                      {saveErrors["clientEmail"]}
                    </FormAlert>
                  )}
                {duplicateEmail && (
                  <FormAlert margin="0 0 0 5px">
                    Email already in use.
                  </FormAlert>
                )}
              </InputWithLabelSection>
            </CommonGrid>

            <InputWithLabelSection>
              <InputLabel>{t("contact_number")}</InputLabel>
              <PhoneInput
                enableSearch
                country={"us"}
                value={phoneNumber}
                onChange={phone => setPhoneNumber(phone)}
                inputClass="phone-number-input"
                buttonClass="phone-number-flag-dropdown"
              />
            </InputWithLabelSection>
            <StaticTaskLocationModal
              isOpen={staticLocationModalOpen}
              toggle={() => {
                setStaticLocationModalOpen(false);
                setSelectedStaticLocation(null);
              }}
              taskLocation={selectedStaticLocation}
              locationIndex={locationIndex}
            />
          </AddClientContainerNew>
          <>
            <CommonCardContainer style={{ marginTop: "0px" }} bgColor="#EDF8FE">
              <CommonText fontWeight="600" margin="0 0 15px 0">
                Locations
              </CommonText>
              <CommonFlex disableResponsive direction="column" gap="12px">
                {clientLocationList && clientLocationList.length > 0 ? (
                  clientLocationList.map((item, index) => (
                    <LocationItem
                      key={index}
                      onMouseEnter={() => onHoverChange(index)}
                      onMouseLeave={() => onHoverChange(null)}
                    >
                      <LocationContent>
                        <CommonImage src={LocationIcon} size="20px" />
                        <div>
                          <CommonText fontWeight="600" fontSize="14px">
                            {item.name}
                          </CommonText>
                          <CommonText fontSize="12px" color="#666">
                            {item.address}
                          </CommonText>
                        </div>
                      </LocationContent>
                      <CommonImage
                        src={item.default ? defaultLocationIcon : defaultHoverLocationIcon}
                        cursor="pointer"
                        onClick={!item.default ? () => {
                          const updatedList = clientLocationList.map(loc => ({
                            ...loc,
                            default: loc.tempId === item.tempId || loc.id === item.id,
                          }));
                          setClientLocationList(updatedList);
                        } : undefined}
                        style={{cursor: item.default ? "default" : "pointer"}}
                      />
                      <MapButton
                        onClick={() => handleShowLocation(item, index)}
                      >
                        Map
                      </MapButton>
                      <ThreeDotDropdown
                        options={[
                          { label: t("delete_location"), action: "delete" },
                        ]}
                        onSelect={(option) => {
                          if (option.action === "delete") {
                            handleClientLocationDelete(index);
                          }
                        }}
                      />
                    </LocationItem>
                  ))
                ) : (
                  <LocationItem>
                    <LocationContent>
                      <CommonText fontSize="14px" color="#999">
                        No locations added
                      </CommonText>
                    </LocationContent>
                  </LocationItem>
                )}
              </CommonFlex>
              <CommonFlex
                justifyContent="flex-start"
                margin="15px 0 0 0"
                width="100%"
              >
                <ButtonTakingFullWidth
                  borderRadius="8px"
                  margin="0"
                  borderColor="#2266EF"
                  onClick={() => addLocationToggle()}
                >
                  <ButtonIcon src={PlusBlack} alt="plus" />
                  {clientLocationList && clientLocationList.length >= 1
                    ? t("add_more_location")
                    : t("add_location")}
                </ButtonTakingFullWidth>
              </CommonFlex>
            </CommonCardContainer>
          </>
        </CommonGrid>
        <HorizontalLineDivider margin="5px 0" />
        <CommonFlex responsiveBreakpoint="768px" gap="15px" margin="0px 0 0 0">
          {/* <WhiteButton type="cancel" onClick={() => cancelFunction()}>
            {t("cancel")}
          </WhiteButton> */}
          <PrimaryButton
            padding={props.isLoading ? "0 15px" : "0 35px"}
            onClick={!props.isLoading ? () => handleSave() : ""}
            width="50%"
          >
            {props.isLoading ? (
              <ButtonTextLoader loadingText="Saving" fontSize="13px" />
            ) : (
              t("add_customer")
            )}
          </PrimaryButton>
        </CommonFlex>
      </ContainerNew>
    </div>
  );
};

export default AddClient;